export const UserRole = Object.freeze({
  adviser: 'ROLE_ADVISER',
  networkManager: 'ROLE_NETWORK_MANAGER',
  companyManager: 'ROLE_COMPANY_MANAGER',
  teamManager: 'ROLE_TEAM_MANAGER',
  teamMember: 'ROLE_TEAM_MEMBER',
  teamChampion: 'ROLE_TEAM_CHAMPION',
  companyMember: 'ROLE_COMPANY_MEMBER',
  reporter: 'ROLE_REPORTER',
});

export const UserEnterpriseRoles = [
  UserRole.companyManager,
  UserRole.teamManager,
  UserRole.teamMember,
  UserRole.adviser,
];

export const UserEnterpriseFeatureRoles = [
  UserRole.networkManager,
  UserRole.companyMember,
  UserRole.reporter,
];

export const UserRoleLabel = Object.freeze({
  [UserRole.adviser]: 'Adviser',
  [UserRole.networkManager]: 'Network Manager',
  [UserRole.companyManager]: 'Company Manager',
  [UserRole.teamManager]: 'Team Manager',
  [UserRole.teamMember]: 'Team Member',
  [UserRole.teamChampion]: 'Team Champion',
  [UserRole.companyMember]: 'Company Member',
  [UserRole.reporter]: 'Reporter',
});

export const UserRoleDescriptions = Object.freeze({
  [UserRole.adviser]: ['Access to Adviser mobile app', 'Access to learning hub'],
  [UserRole.companyManager]: ['Create new teams', 'Manage all teams and users'],
  [UserRole.teamManager]: ['Manage team administrators', 'Invite new team members', 'Manage users'],
  [UserRole.teamMember]: ['Create & manage funding searches', 'Access to learning hub'],
});

export const UserRoleIcon = Object.freeze({
  [UserRole.networkManager]: 'network',
  [UserRole.reporter]: 'chart',
});
